import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ShowDetailClockHourComponent } from './show-detail-clock-hours.component';
import { ShowDetailClockHours } from './show-detail-clock-hours.types';

@Injectable({
  providedIn: 'root',
})
export class ShowDetailClockHourService {
  private refreshListSource = new Subject<ShowDetailClockHours.Result>();

  refreshList$ = this.refreshListSource.asObservable();

  constructor(private dialog: MatDialog) {}

  open(
    config: MatDialogConfig<ShowDetailClockHours.Params> = new MatDialogConfig()
  ) {
    config.disableClose = true;
    const dialogRef = this.dialog.open(ShowDetailClockHourComponent, config);

    return dialogRef.afterClosed().pipe(
      tap((res) => {
        this.refreshListSource.next(res);
      })
    );
  }
}
